import React from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../../services/auth';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !authService.isAdmin()) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
